import * as Yup from 'yup';
import dayjs from 'dayjs';
import 'dayjs/locale/pt-br';
import { cpf, cnpj } from 'cpf-cnpj-validator';

const customParseFormat = require('dayjs/plugin/customParseFormat');
dayjs.extend(customParseFormat);
const today = dayjs();

Yup.addMethod(Yup.date, 'format', function (formats) {
  return this.transform((value, originalValue) => {
    return dayjs(originalValue, formats, true).isValid() ? dayjs(originalValue, formats).toDate() : new Date('');
  });
});

function validateEmail(email: any) {
  const regex = /^(([^<>()[\]\.,;:\s@\"]+(\.[^<>()[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i;
  return regex.test(email);
}

export const schema = Yup.object().shape({
  document: Yup.string()
    .required('Documento obrigatório')
    .test('Validating CPF', 'Documento inválido', (value: string) => {
      return cpf.isValid(value);
    }),
  documentPJ: Yup.string()
    .required('Documento obrigatório')
    .test('Validating CNPJ', 'Documento inválido', (value: string) => {
      return cnpj.isValid(value);
    }),
  documentSpouse: Yup.string()
    .required('Documento obrigatório')
    .test('Validating document', 'Documento inválido', (value: string) => {
      return cpf.isValid(value) || cnpj.isValid(value);
    }),
  birthdate: Yup.date()
    .required('Data de nascimento obrigatório')
    // @ts-ignore
    .format('DD/MM/YYYY')
    .max(today.subtract(18, 'year'), 'Você precisa ter mais de 18 anos')
    .min(today.subtract(80, 'year'), 'Você precisa ter menos de 80 anos')
    .typeError('Data de nascimento obrigatório'),
  birthdateSpouse: Yup.date()
    .required('Data de nascimento obrigatório')
    // @ts-ignore
    .format('DD/MM/YYYY')
    .max(today.subtract(18, 'year'), 'Você precisa ter mais de 18 anos')
    .min(today.subtract(80, 'year'), 'Você precisa ter menos de 80 anos')
    .typeError('Data de nascimento obrigatório'),
  phoneNumber: Yup.string()
    .required('Número obrigatório')
    .matches(/^\([1-9]{2}\) (?:[2-8]|9[0-9])[0-9]{3}\-[0-9]{4}$/, 'Número de telefone inválido'),
  phoneNumberSpouse: Yup.string()
    .required('Número obrigatório')
    .matches(/^\([1-9]{2}\) (?:[2-8]|9[0-9])[0-9]{3}\-[0-9]{4}$/, 'Número de telefone inválido'),
  postalCode: Yup.string().required('CEP obrigatório').min(10, 'Insira um CEP válido'),
  firstName: Yup.string()
    .trim('O nome não pode estar em branco')
    .matches(/^([^0-9]*)$/, {
      message: 'O nome não pode conter números'
    })
    .required('Nome obrigatório')
    .min(3, 'Digite pelo menos 3 letras'),
  lastName: Yup.string()
    .trim('O sobrenome não pode estar em branco')
    .matches(/^([^0-9]*)$/, {
      message: 'O sobrenome não pode conter números'
    })
    .required('Sobrenome obrigatório')
    .min(2, 'Digite pelo menos 2 letras'),
  companyName: Yup.string().required('Nome da empresa obrigatório').min(2, 'Digite pelo menos 2 letras'),
  email: Yup.string()
    .test('Valida e-mail', 'Digite um e-mail válido', function (value: any) {
      return validateEmail(value);
    })
    .required('E-mail obrigatório.'),
  valueImmobile: Yup.string().required('Valor do imóvel obrigatório'),
  cep: Yup.string().required('Cep obrigatório'),
  addressLine1: Yup.string().required('Endereço obrigatório').min(2, 'Digite pelo menos 2 letras'),
  number: Yup.string().required('Número obrigatório'),
  city: Yup.string().required('Cidade obrigatório'),
  valueCredit: Yup.string().required('Valor crédito obrigatório'),
  deadLine: Yup.string().required('Prazo obrigatório')
});
